






import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import DatePicker from '@/components/TimelineDatePicker.vue'

import Timeline from '@/models/Timeline'
import Node from '@/models/Node'
import { SendPacket } from '@/networking/SendPacket'
import Packet, { PacketType } from '@/models/Packet'
import BInputLimited from '@/components/input_limited/BInputLimited.vue'
import EditMapModalContent from './EditMap/EditMapModalContent.vue'
import Project from '@/models/Project'

@Component({
	refs: ['content', 'modal'],
	components: 
	{
		DatePicker,
		BInputLimited,
		EditMapModalContent
	}
})
export default class EditTimelineModal extends Vue 
{
	@Prop( Boolean ) readonly suppressNetworkMessage! : Boolean;
	@Prop({ default: -1 }) readonly defaultMapPin!: Number;
	
	edit_project : Project | null = null;
	initialized = false;
	timeline : Timeline = new Timeline;
	mapNodeID : Number = -1;
	private subKey = 0;
	
	mounted()
	{
		this.reset();
	}

	get name()
	{
		return this.timeline.name.trim();
	}

	set name(value : string)
	{
		this.timeline.name = value;
	}

	get formValid() : Boolean 
	{
		return (this.projectData.type == 'none' || this.mapNodeID != -1) && this.name.length > 0;
	}
	
	get projectData()
	{
		return JSON.parse((this.$store.state as any).project.project.data);
	}

	get mapNodes()
	{
		let arr = new Map<Number, Object>();
		/*let none = new Node();
		none.name = "None";
		arr.set(-1, none);*/
		
		for (let k of this.$store.state.project.mapNodes.keys())
		{
			let v = this.$store.state.project.mapNodes.get(k);
			arr.set(k as any, v);
		}
		return arr;
	}
	
	get mapToTimeline()
	{
		return this.$store.getters.mapToTimeline;
	}

	get currentMapNode()
	{
		return this.mapNodes.get(this.mapNodeID);
	}

	// Methods
	show()
	{
		++this.subKey
		this.reset();
		if (!this.initialized)
		{
			this.initialized = true;
			this.$nextTick(() =>
			{
				(this.$refs as any).modal.show();
			});
			return;
		}
		(this.$refs as any).modal.show();
	}

	hide()
	{
		if (!this.initialized)
		{
			this.initialized = true;
			this.$nextTick(() =>
			{
				(this.$refs as any).modal.hide();
			});
			return;
		}
		(this.$refs as any).modal.hide();
	}

	changeMapNode(id : Number)
	{
		this.mapNodeID = id;
	}

	reset()
	{
		this.edit_project = Object.assign(new Project, this.$store.state.project.project);
		this.$set(this, 'timeline', new Timeline);
		this.mapNodeID = this.defaultMapPin;
	}
}

